import { render, staticRenderFns } from "./navigation-panel.vue?vue&type=template&id=3bbe829c&scoped=true"
import script from "./navigation-panel.vue?vue&type=script&lang=js"
export * from "./navigation-panel.vue?vue&type=script&lang=js"
import style0 from "./navigation-panel.vue?vue&type=style&index=0&id=3bbe829c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbe829c",
  null
  
)

export default component.exports